import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { LANGUAGE_CN } from '../../_config/constant';
import { getLocale, shallowEqual, useDispatch, useIntl, useSelector } from 'umi';
import moment from 'moment';
import { uniqBy } from 'lodash-es';
import { v4 as uid } from 'uuid';
import RangePicker from '@/pages/home/components/RangePicker';
import { Input } from 'tea-component';
import RangePickerLeft from '../../components/RangePickerLeft';
import SvgIcon from '@/pages/home/components/SvgIcon';
import { getRangeTimeLimitMsg, isRangeTimeOverLimit } from '@/pages/dashboard/utils/utils';
import { RANGE_TIME_LIMIT, RANGE_TIME_LIMIT_BY_GAME, RANGE_TIME_LIMIT_NOT_GLOBAL } from '@/pages/dashboard/utils/_config/constant';
import './dateComparesionExralFilter.scss';
import CommonBubble from '@home/components/CommonBubble';
import FormatHtmlTextToReact from '@home/components/FormatHtmlTextToReact';
import { getLanguage } from '@home/utils/common';
import classNames from 'classnames';
import { IS_GLOBAL } from '@home/_config/config';

const START_OF_DATE = '2020-01-01';
const START_OF_WEEK = 1;

const RenderRangeDate = (props: any) => {
  const { dateValue, setDateValue, latestDate, dateFilterKey, locale, isReseted, onOverRangeTimeLimit, hasDeleteIcon, isNotLimitTime, onDelete, deleteTooltip } = props || {};
  const isEn = locale === 'en-US';
  const [inputValue, setInputValue] = useState(dateValue?.name);
  const { formatMessage } = useIntl();
  const { gameConfig } = useSelector((state: any) => ({
    gameConfig: state?.dashboardSetting?.gameConfig || {}
  }), shallowEqual);
  const gameCode = gameConfig?.game_code;
  const currentDataFrame = useSelector((state: any) => state?.dashboard?.currentGame?.data_frame);
  const isCasual = currentDataFrame === 'casual';
  const startOfTime = START_OF_DATE;
  const rangeTimeLimitMsg = getRangeTimeLimitMsg(gameCode);

  const handleInputChange = (val: string) => {
    setInputValue(val);
    setDateValue({
      ...dateValue,
      name: val,
    });
  };

  useEffect(() => {
    setInputValue(dateValue?.name);
  }, [dateValue]);

  const errorVal = useMemo(() => {
    if (!inputValue?.trim()) {
      return formatMessage({ id: 'form_error_message_empty' });
    }
    if (!isCasual && inputValue?.length > 30) {
      return formatMessage({ id: 'form_error_message_empty_30_limit' });
    }
    return false;
  }, [inputValue, formatMessage, isCasual]);

  const eventTypeClick = (obj: any) => {
    const nameVal = isEn ? obj?.name : obj?.nameCN;
    const { start_date: startDate, end_date: endDate } = obj;
    setInputValue(nameVal);
    const dateValueArr = [moment(startDate), moment(endDate)];
    setDateValue({
      ...dateValue,
      name: nameVal,
      value: dateValueArr
    });
  };
  const isOverRangeTimeLimit = useMemo(() => {
    if (isNotLimitTime) return false;
    if (!dateValue?.value?.[0] || !dateValue?.value?.[1]) return false;
    const timeLimit = gameCode && RANGE_TIME_LIMIT_BY_GAME[gameCode] ? RANGE_TIME_LIMIT_BY_GAME[gameCode] : RANGE_TIME_LIMIT;
    return isRangeTimeOverLimit(dateValue.value[0], dateValue.value[1], 'years', timeLimit);
  }, [dateValue, isNotLimitTime, gameCode]);

  return (<div 
    className={classNames(
      'search-item search-item-date dbd-pc-console-date-filter-extra-filter-box',
      { 'dbd-pc-console-date-filter-extra-filter-error': isOverRangeTimeLimit },
      { 'dbd-pc-console-date-filter-extra-filter-box-wide': isCasual }
    )}>
    {/* <div className='dbd-pc-console-date-filter-extra-filter-title'>{dateValue?.name}</div> */}
    <Input
      className={classNames(
        'dbd-pc-console-date-filter-extra-filter-title',
        { 'dbd-pc-date-filter-red': errorVal },
        { 'dbd-pc-console-date-filter-extra-filter-title-wide': isCasual },
      )}
      value={inputValue}
      title={isCasual ? (inputValue || '') : ''}
      onChange={handleInputChange} />

    <CommonBubble
      visible={isOverRangeTimeLimit}
      placement="right"
      style={{ maxWidth: "365px" }}
      placementOffset={hasDeleteIcon ? [0, 335] : [0, 300]}
      content={<FormatHtmlTextToReact text={getLanguage(isEn, rangeTimeLimitMsg.en, rangeTimeLimitMsg.cn)} />}
      error
      escapeWithReference
      flipped={false}
      destroyOnClose={false}
      popupContainer={() => document.querySelector(".search-item-date") as HTMLElement}
    >
      <RangePicker
        type='date'
        latestDate={latestDate}
        value={dateValue?.value}
        startOfTime={START_OF_DATE}
        overlayClassName='dbd-range-picker-overlay'
        setShortcutOption={() => {
          return <RangePickerLeft
            dateFilterKey={dateFilterKey}
            latestDate={latestDate}
            startOfTime={startOfTime}
            seasonInfo={gameConfig?.season_info}
            eventTypeClick={eventTypeClick}/>;
        }}
        className="search-border"
        typeList={['date']}
        showSelectType={true}
        startOfWeek={START_OF_WEEK}
        language={locale === LANGUAGE_CN ? 'cn' : 'en'}
        onChange={(value: any, type: string) => {
          // 计算是否超过时间限制
          // 根据 gameCode 获取对应的时间限制，如果没有配置则使用默认值
          const timeLimit = IS_GLOBAL ? (RANGE_TIME_LIMIT_BY_GAME[gameCode] || RANGE_TIME_LIMIT) : RANGE_TIME_LIMIT_NOT_GLOBAL;
          const overRangeTimeLimit = isRangeTimeOverLimit(value[0], value[1], 'years', timeLimit);
          
          setDateValue({
            ...dateValue,
            value,
            type,
          });
          // 通知父组件时间范围超限状态
          onOverRangeTimeLimit?.(dateFilterKey, overRangeTimeLimit, isNotLimitTime);
        }}
        isReseted={isReseted}
        // {...restProps}
        // defaultValue={componentDefault}
      />
    </CommonBubble>
    {onDelete ? (
      <CommonBubble
        dark
        content={deleteTooltip}
        arrowPointAtCenter
        placement="top"
      >
        <div className='dbd-pc-console-date-filter-extra-filter-div' onClick={onDelete}>
          <SvgIcon type='clonse' className='dbd-pc-console-date-filter-extra-filter-delete' />
        </div>
      </CommonBubble>
    ) : (
      <div className='dbd-pc-console-date-filter-extra-filter-div' style={{ visibility: 'hidden' }} />
    )}
    {errorVal && <p className='pc-console-date-filter-error'>{errorVal}</p>}
  </div>);
};

const DateComparesionExralFilter = (props: any) => {
  const { isReseted, statiscDate, setStaticsDate, contrastDate, setContrastDate, latestDate, onOverRangeTimeLimit, isNotLimitTime } = props;
  const locale = getLocale();
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const rangePickerLeftData = useSelector((state: any) => 
    state.rangePikerLeft?.rangePickerLeftData
  , shallowEqual);
  
  // 状态管理：跟踪所有日期范围的overRangeTimeLimit状态
  const [overRangeTimeLimitStates, setOverRangeTimeLimitStates] = useState<Record<string, boolean>>({});
  
  const isDisabled = useMemo(() => 
    contrastDate?.length >= 3
  , [contrastDate]);

  // 计算是否所有日期范围都通过了验证
  const isAllDateRangesValid = useMemo(() => {
    // 检查主日期范围
    const mainDateValid = !overRangeTimeLimitStates.normal;
    
    // 检查所有对比日期范围
    const contrastDatesValid = contrastDate?.every((item: any) => 
      !overRangeTimeLimitStates[`contrastDate${item?.filterId}`]
    ) ?? true;
    
    return mainDateValid && contrastDatesValid;
  }, [overRangeTimeLimitStates, contrastDate]);

  // 处理日期范围超限状态更新
  const handleOverRangeTimeLimitUpdate = useCallback((dateFilterKey: string, isOverLimit: boolean) => {
    setOverRangeTimeLimitStates(prev => ({
      ...prev,
      [dateFilterKey]: isOverLimit
    }));
    
    // 同时调用父组件的回调
    onOverRangeTimeLimit?.(dateFilterKey, isOverLimit);
  }, [onOverRangeTimeLimit]);

  // 当验证状态改变时，通知父组件
  useEffect(() => {
    // 可以通过props传递一个回调函数来通知父组件验证状态
    if (props.onValidationChange) {
      props.onValidationChange(isAllDateRangesValid);
    }
  }, [isAllDateRangesValid, props]);

  const addContrastFilter = useCallback(() => {
    if (isDisabled) {
      return;
    }
  
    let newName = `Contrast Date${contrastDate.length + 1}`;
    let isUnique = !contrastDate.some((item: { name: string; }) => item.name === newName);
  
    if (!isUnique) {
      let index = 1;
      while (!isUnique) {
        newName = `Contrast Date${index}`;
        isUnique = !contrastDate.some((item: { name: string; }) => item.name === newName);
        index++;
      }
    }
    setContrastDate([
      ...contrastDate,
      {
        type: 'date',
        filterId: uid(),
        name: newName,
        value: [moment().subtract(28, "day"), moment().subtract(15, "day")]
      }
    ]);
  }, [locale, contrastDate, isDisabled]);

  const deleteContrastFilter = useCallback((filterId: string) => {
    const contrastDateVal = contrastDate?.filter((item: any) => item?.filterId !== filterId);
    // 不能删除的时候更新另外的对比时间筛选器，因为对应的名称和时间范围用户已经编辑好
    setContrastDate(contrastDateVal);
    
    // 删除对应的overRangeTimeLimit状态
    setOverRangeTimeLimitStates(prev => {
      const newStates = { ...prev };
      delete newStates[`contrastDate${filterId}`];
      return newStates;
    });
    
    // 通知父组件该日期范围已被删除
    handleOverRangeTimeLimitUpdate(`contrastDate${filterId}`, false);
    
    dispatch({
      type: 'rangePikerLeft/setRangePickerLeftData',
      payload: {
        data: uniqBy([{
          dateFilterKey: `contrastDate${filterId}`,
          tabActiveTab: '',
          selectedEventId: '',
          eventSelectedChild: '',
        }, ...(rangePickerLeftData || [])], 'dateFilterKey')
      },
    });
  }, [locale, contrastDate]);


  return <div className='dbd-extral-filter dbd-pc-console-date-filter-extral'>
    <div className='dbd-pc-console-date-filter-extral-title'>{formatMessage({ id: 'pc_console_comparison_set_comparsion_time' })}</div>
    <div className='dbd-pc-console-date-filter-extra-content'>
      <RenderRangeDate
        // componentDefault={componentDefault}
        isReseted={isReseted}
        dateFilterKey='noraml'
        latestDate={latestDate}
        dateValue={statiscDate}
        setDateValue={setStaticsDate}
        locale={locale}
        onOverRangeTimeLimit={handleOverRangeTimeLimitUpdate}
        hasDeleteIcon={false}
        isNotLimitTime={isNotLimitTime}
      />
    </div>
    <div className='dbd-pc-console-date-filter-extra-content'>
      {
        contrastDate?.map((item: { filterId: React.Key | null | undefined; }, index: number) => (
            <RenderRangeDate
              key={item?.filterId}
              // componentDefault={componentDefault}
              isReseted={isReseted}
              dateValue={contrastDate?.[index]}
              dateFilterKey={`contrastDate${item?.filterId}`}
              setDateValue={
                (valueObj: { filterId: string; value: any; type: string; name: string; }) => {
                  const { filterId, value, type, name } = valueObj;
                  const contrastDateVal = contrastDate?.map((filterValItem: { filterId: string; }) => {
                    if (filterValItem?.filterId === filterId) {
                      return {
                        ...filterValItem,
                        value,
                        type,
                        name
                      };
                    }
                    return filterValItem;
                  });
                  setContrastDate(contrastDateVal);
                }
              }
              onOverRangeTimeLimit={handleOverRangeTimeLimitUpdate}
              locale={locale}
              hasDeleteIcon={true}
              isNotLimitTime={isNotLimitTime}
              onDelete={() => deleteContrastFilter(item?.filterId)}
              deleteTooltip={formatMessage({ id: 'pc_console_comparison_romeve_time' })}
            />
        ))
      }

    </div>

    <CommonBubble
      dark
      content={isDisabled ? formatMessage({ id: 'pc_console_comparison_Up_to_6_times' }) : ''}
      arrowPointAtCenter
      placement="top"
    >
      <div className={`dbd-pc-console-date-filter-extra-add ${isDisabled ? 'dbd-pc-console-date-filter-extra-disabled' : ''}`}
        onClick={addContrastFilter}>
        <SvgIcon type='add-bg-icon' /> {formatMessage({ id: 'comparison_analysis_date_comparison_contrast_date' })}
      </div>
    </CommonBubble>
  </div>;
};

export default DateComparesionExralFilter;
